module.exports = __webpack_public_path__ + "static/media/hours.6dd88bf9.svg";